export enum DispositivosEnum {
  MOBILE,
  IPAD,
  TABLET,
  DESKTOP
}
